export default __webpack_public_path__ + "static/bg-tac-3cca311a56f500d3112f86f4ced47d36.jpg";